import Collection from "../../data-structures/collection"
import AiAgent, {AiAgentAccess} from "./ai-agent"

export default class AiAgentsCollection extends Collection<AiAgent> {

    static initFromJson(data:JSONArray):AiAgentsCollection {
        const collection = new AiAgentsCollection([])
        _.map(data, (record:JSONObject) => collection.add(new AiAgent(record)))
        return collection
    }

    sort() {
        this.models = _.orderBy(this.models, [(m:AiAgent) => m.momentCreated], ['desc'])
    }

    filterByCompany(companyId:ID) {
        const filtered = new AiAgentsCollection(_.filter(this.models, (m:AiAgent) =>
            String(m.companyId) === String(companyId) && !m.isDeleted
        ))
        filtered.sort()
        return filtered
    }

    filterByUserAccess(userId:ID) {
        const filtered = new AiAgentsCollection(_.filter(this.models, (m:AiAgent) =>
            !m.isDeleted &&
            (m.access === AiAgentAccess.COMPANY || String(m.userId) === String(userId))
        ))
        filtered.sort()
        return filtered
    }

    // reset(data: any[]) {
    //
    //     const models : AiAgent[] = []
    //     _.map(data, (record:JSONObject) => models.push(new AiAgent(record)))
    //     this.reset(models)
    //
    // }
}
